module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section_hd"
  }, [_c('a', {
    attrs: {
      "id": "rec"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "green"
  }, [_vm._v("No. 1")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('h1', [_c('span', {
    staticClass: "green"
  }, [_vm._v("Bloody Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "pull_quote"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("This spicy, zesty brunch drink opens the door to a wide range of savory sippers—and no, they don’t all contain tomato juice. The most obvious variations experiment with different spirits in place of classic vodka: tequila transforms Mary to Maria, for example. Or switch out the tomato juice component for carrot juice to create the not-so-classic Bloody Bunny.")]), _vm._v(" "), _c('p', {
    staticClass: "pull_quote"
  }, [_vm._v("Or skip the juice altogether and veer toward other piquant, not-too-sweet cocktails, such as the beer-based Michelada, the savory Dirty Martini, or even the Coronation, which uses the salinity of dry sherry to mouthwatering effect.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523da0f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07chapter01.vue
// module id = 75
// module chunks = 0